import { render, staticRenderFns } from "./shortMessageDialog.vue?vue&type=template&id=35ad9160&scoped=true&"
import script from "./shortMessageDialog.vue?vue&type=script&lang=js&"
export * from "./shortMessageDialog.vue?vue&type=script&lang=js&"
import style0 from "./shortMessageDialog.vue?vue&type=style&index=0&id=35ad9160&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ad9160",
  null
  
)

export default component.exports